import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@material-ui/core";
import React from "react";

function DeleteBannerDialog({ show, handleClose, handleRemoveAndClose }) {
  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          آیا از حذف این بنر اطمینان دارید ؟
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRemoveAndClose} color="primary">
          تایید
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteBannerDialog;
